import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { Button, Col, Modal, ModalBody, ModalHeader, Row, Card, CardBody } from 'reactstrap';
import { connect } from 'react-redux';
import AddLocationAltIcon from '@mui/icons-material/AddLocationAlt';
import renderToggleButtonField from 'src/shared/components/form/ToggleButton';
import { GRL_URL } from '../../../../../utils/pnd/PndConstants';
import renderSelectField from 'src/shared/components/form/Select';
import { isNumber, mobileNoLength, mobileNoFormat, required, validateUaeLandline } from '../../../../../utils/validationUtils';
import BusinessIcon from '@mui/icons-material/Business';
import ContactPhoneIcon from '@mui/icons-material/ContactPhone';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import SaveIcon from '@mui/icons-material/Save';
import PhoneIcon from '@mui/icons-material/Phone';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import BadgeIcon from '@mui/icons-material/Badge';

// Compact Input Field Renderer
const renderCompactField = ({ input, placeholder, type, meta: { touched, error, warning }, disabled, icon: Icon }) => (
    <div>
        <div className={`input-group input-group-sm ${touched && error ? 'has-validation' : ''}`}>
            {Icon && (
                <span className="input-group-text bg-light border-end-0 text-muted" style={{ padding: '0.25rem 0.5rem' }}>
                    <Icon style={{ fontSize: '1rem' }} />
                </span>
            )}
            <input
                {...input}
                className={`form-control form-control-sm ${touched && error ? 'is-invalid' : ''} ${Icon ? 'border-start-0' : ''}`}
                placeholder={placeholder}
                type={type}
                disabled={disabled}
                style={{ fontSize: '0.85rem' }}
            />
            {touched && ((error && <div className="invalid-feedback">{error}</div>) || (warning && <div className="text-warning small">{warning}</div>))}
        </div>
    </div>
);

const HubAddOrUpdate = ({ handleSubmit, setMapData, setLatitude, setLongitide, hubData, status, address, setGrl }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isAddress, setAddress] = useState(null);
    const [apaIframeUrl] = useState(GRL_URL);

    const apaFrameRef = useRef(null);
    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);
    };

    const handleFindLocation = () => {
        toggleModal(); // Open the modal
        handleMessageToIframe(); // Send message to iframe
    };

    const handleMessageToIframe = () => {
        const datajson = '{"RequestID": ' + Math.floor((Math.random() * 20) + 1) + ',"MessageType":1,"AddressElements": [{"AddressElementTypeCode": 1,"Value":""},{"AddressElementTypeCode":2,"Value": ""},{ "AddressElementTypeCode": 3,"Value": ""},{"AddressElementTypeCode":4,"Value": ""},{"AddressElementTypeCode": 5,"Value":"520950"},{"AddressElementTypeCode": 6,"Value":"" },{"AddressElementTypeCode": 7, "Value": "" },{"AddressElementTypeCode": 8,"Value":""}]}';
        if (apaFrameRef.current) {
            apaFrameRef.current.contentWindow.postMessage(datajson, '*');
            window.addEventListener('message', handleMessageFromIframe);
        } else {
            console.error('iframe element not found');
        }
    };

    let deliveryAddress = "";
    const handleMessageFromIframe = (event) => {
        if (event && event?.data) {
            try {
                const jsonRegex = /^\s*(\{.*\}|\[.*\])\s*$/;
                if (jsonRegex.test(event.data)) {
                    const data_from_apa = JSON.parse(event.data);
                    const buildingName = data_from_apa.AddressElements.find(element => element.AddressElementTypeCode === 6);
                    const landmark = data_from_apa.AddressElements.find(element => element.AddressElementTypeCode === 4);
                    const street = data_from_apa.AddressElements.find(element => element.AddressElementTypeCode === 3);
                    const area = data_from_apa.AddressElements.find(element => element.AddressElementTypeCode === 2);
                    const zone = data_from_apa.AddressElements.find(element => element.AddressElementTypeCode === 7);
                    const city = data_from_apa.AddressElements.find(element => element.AddressElementTypeCode === 8);
                    const emirates = data_from_apa.AddressElements.find(element => element.AddressElementTypeCode === 1);
                    const latitude = data_from_apa.AddressElements.find(element => element.AddressElementTypeCode === 10);
                    const longitude = data_from_apa.AddressElements.find(element => element.AddressElementTypeCode === 9);
                    const grl = data_from_apa.AddressElements.find(element => element.AddressElementTypeCode === 5);

                    if (buildingName && buildingName?.Value !== "") {
                        deliveryAddress = deliveryAddress + buildingName.Value + ",";
                    }
                    if (buildingName?.Value === "" && landmark?.Value !== "") {
                        deliveryAddress = deliveryAddress + landmark.Value + ",";
                    }
                    if (street?.Value !== "") {
                        deliveryAddress = deliveryAddress + street.Value + ",";
                    }
                    if (area) {
                        deliveryAddress = deliveryAddress + area.Value + ",";
                    }
                    if (zone) {
                        deliveryAddress = deliveryAddress + zone.Value + ",";
                    }
                    if (city) {
                        deliveryAddress = deliveryAddress + city.Value + ",";
                    }
                    if (emirates) {
                        deliveryAddress = deliveryAddress + emirates.Value;
                    }
                    if (deliveryAddress && deliveryAddress.includes(",,")) {
                        setAddress(deliveryAddress.replace(/,,/g, ','));
                        setMapData(deliveryAddress.replace(/,,/g, ','));
                    }
                    if (latitude) {
                        setLatitude(latitude.Value);
                    }
                    if (longitude) {
                        setLongitide(longitude.Value);
                    }
                    if (grl) {
                        setGrl(grl.Value);
                    }
                    // Close the modal after getting the address
                    toggleModal();
                }
            } catch (error) {
                console.error('event.data is not a valid JSON string');
            }
        }
    };

    return (
        <form onSubmit={handleSubmit} className="p-2 bg-light">

            {/* Hub Information Section */}
            <Card className="border-0 shadow-sm mb-2">
                <CardBody className="p-2">
                    <div className="d-flex align-items-center mb-2 text-primary border-bottom pb-1">
                        <BusinessIcon style={{ fontSize: '1.2rem' }} className="me-2" />
                        <h6 className="m-0 fw-bold small text-uppercase">Hub Information</h6>
                    </div>
                    <Row className="g-2">
                        <Col md={6}>
                            <div className="mb-1">
                                <label className="form-label fw-bold text-muted small mb-0" style={{ fontSize: '0.75rem' }}>Hub Name <span className='text-danger'>*</span></label>
                                <Field
                                    name="hubName"
                                    component={renderCompactField}
                                    type="text"
                                    placeholder="Hub Name"
                                    validate={[required]}
                                    icon={BusinessIcon}
                                />
                            </div>
                        </Col>
                        <Col md={6}>
                            <div className="mb-1">
                                <label className="form-label fw-bold text-muted small mb-0" style={{ fontSize: '0.75rem' }}>Hub No. <span className='text-danger'>*</span></label>
                                <Field
                                    name="hubNo"
                                    component={renderCompactField}
                                    type="text"
                                    placeholder="Hub No."
                                    validate={[required]}
                                    icon={BadgeIcon}
                                />
                            </div>
                        </Col>
                    </Row>
                </CardBody>
            </Card>

            {/* Contact Information Section */}
            <Card className="border-0 shadow-sm mb-2">
                <CardBody className="p-2">
                    <div className="d-flex align-items-center mb-2 text-primary border-bottom pb-1">
                        <ContactPhoneIcon style={{ fontSize: '1.2rem' }} className="me-2" />
                        <h6 className="m-0 fw-bold small text-uppercase">Contact Information</h6>
                    </div>
                    <Row className="g-2">
                        <Col md={6}>
                            <div className="mb-1">
                                <label className="form-label fw-bold text-muted small mb-0" style={{ fontSize: '0.75rem' }}>Mobile No. <span className='text-danger'>*</span></label>
                                <Field
                                    name="contactPersonMobileNo"
                                    component={renderCompactField}
                                    type="text"
                                    placeholder="971xxxxxxx"
                                    validate={[required, mobileNoLength, isNumber, mobileNoFormat]}
                                    icon={PhoneIcon}
                                />
                            </div>
                        </Col>
                        <Col md={6}>
                            <div className="mb-1">
                                <label className="form-label fw-bold text-muted small mb-0" style={{ fontSize: '0.75rem' }}>Landline No.</label>
                                <Field
                                    name="phoneNo"
                                    component={renderCompactField}
                                    type="text"
                                    placeholder="04xxxxxxx"
                                    validate={[isNumber, validateUaeLandline]}
                                    icon={LocalPhoneIcon}
                                />
                            </div>
                        </Col>
                    </Row>
                </CardBody>
            </Card>

            {/* Location & Settings Section */}
            <Card className="border-0 shadow-sm mb-2">
                <CardBody className="p-2">
                    <div className="d-flex align-items-center mb-2 text-primary border-bottom pb-1">
                        <LocationOnIcon style={{ fontSize: '1.2rem' }} className="me-2" />
                        <h6 className="m-0 fw-bold small text-uppercase">Location & Settings</h6>
                    </div>
                    <Row className="g-2">
                        <Col md={12}>
                            <div className="mb-1">
                                <label className="form-label fw-bold text-muted small mb-0" style={{ fontSize: '0.75rem' }}>Address <span className='text-danger'>*</span></label>
                                <div className="input-group input-group-sm">
                                    <span className="input-group-text bg-light border-end-0 text-muted" style={{ padding: '0.25rem 0.5rem' }}>
                                        <LocationOnIcon style={{ fontSize: '1rem' }} />
                                    </span>
                                    <input
                                        className="form-control form-control-sm border-start-0"
                                        name="hubAddress"
                                        type="text"
                                        value={isAddress || address || ''}
                                        placeholder="Hub Address"
                                        readOnly
                                        style={{ fontSize: '0.85rem' }}
                                    />
                                    <button
                                        type="button"
                                        className="btn btn-sm btn-success"
                                        onClick={handleFindLocation}
                                        style={{ fontSize: '0.75rem', padding: '0.25rem 0.75rem' }}
                                    >
                                        <AddLocationAltIcon style={{ fontSize: '1rem' }} className="me-1" />
                                        Find Location
                                    </button>
                                </div>
                            </div>
                        </Col>
                        <Col md={6}>
                            <div className="mb-1">
                                <label className="form-label fw-bold text-muted small mb-0" style={{ fontSize: '0.75rem' }}>Express Delivery Within <span className='text-danger'>*</span></label>
                                <Field
                                    validate={[required]}
                                    name="expressDeliveryWithIn"
                                    component={renderSelectField}
                                    options={[
                                        { value: 15, label: "15 Min" },
                                        { value: 30, label: "30 Min" },
                                        { value: 45, label: "45 Min" },
                                        { value: 60, label: "60 Min" },
                                    ]}
                                    placeholder="Select Express Delivery"
                                />
                            </div>
                        </Col>
                        <Col md={6}>
                            <div className="mb-1">
                                <label className="form-label fw-bold text-muted small mb-1 d-block" style={{ fontSize: '0.7rem' }}>OPERATIONAL STATUS</label>
                                <Field
                                    name="status"
                                    component={renderToggleButtonField}
                                    defaultChecked={status}
                                />
                            </div>
                        </Col>
                    </Row>
                </CardBody>
            </Card>

            {/* Action Bar */}
            <div className="d-flex justify-content-end pt-2 mt-2 border-top">
                <Button
                    color="primary"
                    type="submit"
                    size="sm"
                    className="px-4 py-1 rounded-pill shadow-sm d-flex align-items-center"
                    style={{ background: 'linear-gradient(90deg, #00C9FF 0%, #92FE9D 100%)', border: 'none', color: '#000', fontWeight: 'bold', fontSize: '0.85rem' }}
                >
                    <SaveIcon style={{ fontSize: '1rem' }} className="me-1" />
                    {hubData ? 'Update' : 'Save'}
                </Button>
            </div>

            {/* Location Finder Modal */}
            <Modal isOpen={isModalOpen} toggle={toggleModal} size="xl" style={{ maxWidth: '1000px' }}>
                <ModalHeader toggle={toggleModal}>
                    <div className="d-flex align-items-center">
                        <LocationOnIcon className="me-2 text-success" style={{ fontSize: '1.5rem' }} />
                        <b>Find Location</b>
                    </div>
                </ModalHeader>
                <ModalBody>
                    <iframe
                        ref={apaFrameRef}
                        src={apaIframeUrl}
                        width="100%"
                        height="400px"
                        title="Get Address"
                        onLoad={handleMessageToIframe}
                        style={{ width: '100%', height: '650px', border: 'none', borderRadius: '8px' }}
                    />
                </ModalBody>
            </Modal>
        </form>
    );
};

HubAddOrUpdate.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
};

const mapStateToProps = (state, data) => {
    if (data && data.hubData) {
        return {
            initialValues: {
                hubName: data.hubData.hubName,
                hubNo: data.hubData.hubNo,
                phoneNo: data.hubData.phoneNo,
                longitude: data.hubData.longitude,
                latitude: data.hubData.latitude,
                address: data.hubData.address,
                hubId: data.hubData.hubId,
                contactPersonMobileNo: data?.hubData?.contactPersonMobileNo,
                expressDeliveryWithIn: { "value": data?.hubData.expressDeliveryWithIn, "label": data?.hubData.expressDeliveryWithIn },
                status: data.hubData?.status
            }
        }
    }
    return {};
}

export default connect(mapStateToProps)(reduxForm({ form: 'HubAddOrUpdateForm', enableReinitialize: true })(HubAddOrUpdate));